import { Box, Button, Divider, Link, Text, VStack } from '@chakra-ui/react'
import { useEffect, useMemo, useState } from 'react'

import { DetailField } from '../../../components/DetailField'
import { LoadingBlock } from '../../../components/Loading'
import { useAppToast, formatPhone } from '../../../helpers'
import { IQuestion, IRefund } from '../../../services/Refunds/interfaces'
import RefundsService from '../../../services/Refunds/RefundsService'
import { ISector } from '../../../services/Sector/SectorService'

interface IAnswer {
  id: number
  value: string | string[]
  question_id: number
  refund_id: number
}

export default function RefundsViewPage({ refundId: id, sectors }: { refundId: number; sectors: ISector[] }) {
  const refundsService = useMemo(() => new RefundsService(), [])
  const [refund, setRefund] = useState<IRefund>()
  const [answers, setAnswers] = useState<IAnswer[]>([])
  const [questions, setQuestions] = useState<IQuestion[]>([])
  const toast = useAppToast()

  const fetchRefund = async () => {
    try {
      const response = await refundsService.getAnswers(id)
      setRefund(response.data.refund)
      setAnswers(response.data.answers)
      setQuestions(response.data.questions)
    } catch {
      toast.error('Erro ao buscar informações da Solicitação Reembolso!')
    }
  }

  useEffect(() => {
    fetchRefund()
  }, [])

  return (
    <>
      {!refund ? (
        <LoadingBlock size="page" />
      ) : (
        <>
          <VStack align="stretch" spacing={4}>
            <DetailField label="Nome" value={refund.name} emptyValue="Sem resposta" />
            <DetailField label="E-mail" value={refund.email} emptyValue="Sem resposta" />
            <DetailField label="Telefone" value={formatPhone(refund.phone)} emptyValue="Sem resposta" />
            <DetailField
              label="Setor"
              value={sectors.find((sector) => sector.id === refund.sector_id)?.name}
              emptyValue="Sem resposta"
            />
          </VStack>

          <Divider my={6} borderWidth="2px" borderColor="gray.400" />

          <VStack align="stretch" spacing={4}>
            {questions.map((question) => {
              const answerValue = answers.find((answer) => answer.question_id === question.id)?.value
              const fileLinks = question.type === 'file' ? [answerValue].flat().filter(Boolean) : []

              return (
                <DetailField key={question.id} label={question.label}>
                  {question.type === 'file' ? (
                    fileLinks.length > 0 ? (
                      <Box display="flex" flexDirection="row" gap={2}>
                        {fileLinks.map((filePath, index) => (
                          <Link href={filePath as string} isExternal key={index}>
                            <Button colorScheme="magenta" size="sm">
                              Ver Arquivo {fileLinks.length > 1 ? index + 1 : ''}
                            </Button>
                          </Link>
                        ))}
                      </Box>
                    ) : (
                      <Text>Sem resposta</Text>
                    )
                  ) : (
                    <Text>{answerValue || 'Sem resposta'}</Text>
                  )}
                </DetailField>
              )
            })}
          </VStack>
        </>
      )}
    </>
  )
}
